import axios from 'axios'

class SessionService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Get a session token to login a user in hibou.legal API
  * @date 16-08-2021
  * @param {String} email
  * @param {String} password
  * @param {String} ip
  * @param {Boolean} userGeolocationAuthorization - If the user authorized geolocation
  * @param {Object} geolocation - Object with {latitude: number, longitude: number} 
  * @returns {Object}
  * @memberof SessionService
  */
  async sessionLogin(email, password, ip, userGeolocationAuthorization = false, geolocation = null) {
    let response = await axios.post(`${this.apiUrl}/session-login`,
      {
        email,
        password,
        ip,
        userGeolocationAuthorization,
        geolocation
      })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Register a new user in Auth0 to create a account in hibou.legal API
  * @date 16-08-2021
  * @param {String} email
  * @param {String} password
  * @returns {Object}
  * @memberof SessionService
  */
  async sessionRegister(email, password) {
    let response = await axios.post(`${this.apiUrl}/session-register`,
      {
        email,
        password
      })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Send email "Change password" to a user registered in hibou.legal API
  * @date 16-08-2021
  * @param {String} email
  * @returns {Object}
  * @memberof SessionService
  */
  async sessionChangePassword(email) {
    let response = await axios.post(`${this.apiUrl}/session-change-password`,
      {
        email
      })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Send email "User Verification" to a verify a new user registered in hibou.legal API
  * @date 16-08-2021
  * @param {String} auth0Id
  * @returns {Object}
  * @memberof SessionService
  */
  async sessionEmailVerification(auth0Id) {
    let response = await axios.post(`${this.apiUrl}/session-email-verification`,
      {
        auth0Id
      })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Block a user after several failed login attempts in hibou.legal API
  * @date 16-08-2021
  * @param {String} email
  * @returns {Object}
  * @memberof SessionService
  */
  async sessionUserBlock(email) {
    let response = await axios.put(`${this.apiUrl}/session-user-block`,
      {
        email
      })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Get the server time from govo.legal API
  * @date 31-10-2022
  * @param {String} auth0Id
  * @returns {Object}
  * @memberof SessionService
  */
  async sessionGetServerTime(timezone) {
    let response = await axios.get(`${this.apiUrl}/server-time?timezone=${encodeURIComponent(timezone)}`)
    return response.data
  }
}
export { SessionService as default }